function capitalizeWord(str) {
  return (
    str.length > 0
      ? `${str[0].toUpperCase()}${str.slice(1).toLowerCase()}`
      : str
  ).trim()
}
export const capitalize = (str) => `${str}`.split(' ').map(capitalizeWord).join(' ')

export const stripHtmlTags = (str = '') => {
  if (typeof str === 'string')
    return str.replace(/<[^>]*>?/gm, '');
  else
    return str;
}
